import { useContext } from "react";
import "./SearchModal.scss";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { useLocation } from "react-router";
import HeaderContainer from "app/pages/Header/HeaderContainer";
import StopoverSearchFormContainer from "app/pages/Stopover/StopoverSearchForm/StopoverSearchFormContainer";
import HotelOnlySearchFormContainer from "app/pages/HotelOnly/HotelOnlySearchForm/HotelOnlySearchFormContainer";
import SmartDPSearchFormContainer from "app/pages/SmartDP/Search/SDPSearchForm/SmartDPSearchFormContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import IconClose from "app/pages/.shared/IconClose";

const SearchForm = ({ isStopover, isSDP, isHotelOnly, onSubmit }) => {
	if (isStopover) {
		return <StopoverSearchFormContainer onSubmit={onSubmit} />;
	}
	if (isSDP) {
		return <SmartDPSearchFormContainer onSubmit={onSubmit} />;
	}
	if (isHotelOnly) {
		return <HotelOnlySearchFormContainer onSubmit={onSubmit} />;
	}
	return null;
};

SearchForm.propTypes = {
	isStopover: PropTypes.bool,
	isSDP: PropTypes.bool,
	isHotelOnly: PropTypes.bool,
	onSubmit: PropTypes.func,
};

const SearchModal = ({ isOpen, onClose }) => {
	const { pathname } = useLocation();
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const isStopover = pathname.includes("stopover");
	const isSDP = pathname.includes("sdp");
	const isHotelOnly = pathname.includes("hotelonly");

	return (
		<Modal
			isOpen={isOpen}
			closeTimeoutMS={200}
			onRequestClose={onClose}
			overlayClassName="search-modal__overlay"
			className="search-modal__content"
		>
			{!isMobile && <HeaderContainer showMenuItems showDialPhone={false} showBackBtn />}

			{isMobile && (
				<section className="search-modal__title">
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold component="h3">
						<FormattedMessage id="sdp.search.home.input.label" />
					</Typography>

					<IconClose
						width={24}
						height={24}
						onClick={onClose}
						className="search-modal__title-close-icon"
					/>
				</section>
			)}

			<SearchForm
				isSDP={isSDP}
				isStopover={isStopover}
				isHotelOnly={isHotelOnly}
				onSubmit={onClose}
			/>
		</Modal>
	);
};

SearchModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default SearchModal;
